import React, { useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { BiChevronRight } from "react-icons/all";
import { FiCheck } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { INPUT_ICON_STATES } from "utils/constants";

import FloatLabel from "./FloatingLabel";

import "./style.scss";

const antIcon = <LoadingOutlined spin />;

const Status = (onIconClick) => ({
  [INPUT_ICON_STATES.SIMPLE]: <></>,
  [INPUT_ICON_STATES.VERIFY]: (
    <div
      onClick={onIconClick}
      className="container--input--status--icon--verify">
      <BiChevronRight size={22} />
    </div>
  ),
  [INPUT_ICON_STATES.LOAD]: (
    <div className="container--input--status--icon--load">
      <Spin indicator={antIcon} />
    </div>
  ),
  [INPUT_ICON_STATES.CHECK]: (
    <div className="container--input--status--icon--check">
      <FiCheck size={22} />
    </div>
  ),
  [INPUT_ICON_STATES.ERROR]: (
    <div
      onClick={onIconClick}
      className="container--input--status--icon--error">
      <IoMdClose size={22} />
    </div>
  ),
});

const WithStatus = ({
  placeholder,
  type,
  icon,
  status,
  onIconClick,
  ...rest
}) => {
  const [inputTpe, setType] = useState(type);
  return (
    <FloatLabel
      className="container--input--status"
      label={placeholder}
      labelLeft={!isEmpty(icon) ? "label--left" : ""}
      {...rest}
      type={type}
      setType={setType}>
      <input
        className={"container--input--status--inputItem"}
        type={inputTpe}
        {...rest}
      />
      <div className={"container--input--status--icon"}>
        {Status(onIconClick)[status]}
      </div>
    </FloatLabel>
  );
};

WithStatus.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(Object.values(INPUT_ICON_STATES)),
  icon: PropTypes.node,
  status: PropTypes.string,
  onIconClick: PropTypes.func,
};

WithStatus.defaultProps = {
  placeholder: "",
  onClick: () => {},
  onIconClick: () => {},
};

export default WithStatus;
